module.exports = window["core-js/modules/es.symbol.iterator.js"];